export default __webpack_public_path__ + "static/media/nav-calc.4302a90e.svg";